import { helpers, ts } from '_core';

// prepareWeightsVsTimeData
export const transform = (localData: ts.types.widgets.TableData, definition: ts.types.signal.Lasso) => {
  const newData = helpers.buildName.signalTableVarName(localData, definition);

  return newData.map((item) => {
    const newItem = { date: item.date } as ts.types.widgets.TableData[number];
    Object.keys(item).forEach((key) => {
      if (key !== 'date') {
        const jointKey = key.split('|').slice(1, key.length).join(' + ');
        newItem[jointKey] = item[key];
      }
    });
    return newItem;
  });
};
